import { render, staticRenderFns } from "./modelCols.vue?vue&type=template&id=724254e4&scoped=true&"
import script from "./modelCols.vue?vue&type=script&lang=js&"
export * from "./modelCols.vue?vue&type=script&lang=js&"
import style0 from "./modelCols.vue?vue&type=style&index=0&id=724254e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724254e4",
  null
  
)

export default component.exports